/* eslint-disable */
import { CLOSE_16 } from "@sznds/icons";
import createSDSIcon from "./icon";

interface IOnboardingOptions extends Partial<HTMLDivElement> {
	onClose: (event: MouseEvent) => void;
}

export function createOnboarding({
	className = "",
	onClose = null,
	...rest
}: IOnboardingOptions): HTMLDivElement {
	const container = Mapy.Util.node("div", {
		className: `ui-onboarding ${className}`,
		...rest,
	}) as HTMLDivElement;
	const closeButton = Mapy.Util.node("button", {
		className: `ui-onboarding__button`,
	}) as HTMLButtonElement;

	closeButton.appendChild(createSDSIcon({
		symbol: CLOSE_16,
	}))
	container.appendChild(closeButton);
	onClose && closeButton.addEventListener("click", onClose);

	return container;
}
